import { createContext, useContext } from 'react';
import { Listing } from '../../../declarations/exclusives/listing';

const Provider = createContext<Listing | null>(null);

export const ListingProvider = Provider.Provider;

export function useListing() {
  return useContext(Provider);
}
